import React, { Component } from 'react';
import './App.css';
import NavBar from './components/navBar/NavBar';
import DashboardPage from './pages/dashboardPage/DashboardPage';
import { PopupController } from './components/popupController/PopupController';
import ReportsPage from './pages/reportsPage/ReportsPage';
import Login from './pages/login/Login';
import { Route, Router, Switch } from 'react-router-dom';
import history from './history';
import UsersPage from './pages/usersPage/UsersPage';
import models from './model/models';
import mainAPI from './api/MainAPI';
import RecommendedReportsPage from './pages/recommendedReportsPage/RecommendedReportsPage';
import CustomReportsPage from './pages/customReportsPage/CustomReportsPage';
import DrugPage from './pages/drugPage/DrugPage';
import CustomReport from './pages/customReport/CustomReport';
import UnitListPage from './pages/unitListPage/UnitListPage';
import UnitDetailsPage from './pages/unitDetailsPage/UnitDetailsPage';
import SettingsPage from './pages/settingsPage/SettingsPage';
import Toasts from './components/toasts/Toasts';
import toasts from './utils/toasts';
import UserDetailsPage from './pages/userDetailsPage/UserDetailsPage';
import SuperAdminSettingsPage from './pages/superAdminSettingsPage/SuperAdminSettingsPage';
import GroupUserListPage from './pages/groupUserListPage/GroupUserListPage';
import DrugDetailsPage from './pages/drugDetailsPage/DrugDetailsPage';
import DrugBoxDetailsPage from './pages/drugBoxDetailsPage/DrugBoxDetailsPage';
import CreateGroupPage from './pages/createGroupPage/CreateGroupPage';
import ActivityMapPage from './pages/activityMapPage/ActivityMapPage';

class App extends Component {
	componentDidMount = async () => {
		document.fonts.load('16px "Helvetica Neue"').then(() => {
			document.body.classList.remove('main-font-loading')
		});
		document.fonts.load('16px "untitled-font-1"').then(() => {
			document.body.classList.remove('icon-font-loading')
		});
		if (localStorage.token) {
			let user = await mainAPI.user.get();
			if (!user) return;
			if (user.role !== 'admin' && user.role !== 'super_admin') {
				toasts.show('You are not and admin');
				delete localStorage.token;
				delete localStorage.user_group_id;
				delete localStorage.num_additional_groups;
				localStorage.clear();
				setTimeout(() => {
					window.location.reload();
				}, 1001);
				return;
			}
			models.user.setCurrent(user);
			for (let i in models) {
				models[i]._subscribeSockets();
			}
		}
	};

	render() {
    const classNames = ['App'];
    const adaAgencyIds = ['1655423163014', '1548633353696'];
    if(adaAgencyIds.includes(localStorage.user_group_id)){
      classNames.push('ada')
    }
		return (
			<div className={classNames.join(' ')}>
				<Toasts />
				<NavBar />
				<div className="pages">
					<Router history={history}>
						<Switch>
							<Route key={0} path="/" exact component={DashboardPage} />
							<Route key={1} path="/login" exact component={Login} />
							<Route key={2} path="/reports" exact component={ReportsPage} />
							<Route key={3} path="/reports/recommended" exact component={RecommendedReportsPage} />
							<Route key={4} path="/reports/custom" exact component={CustomReportsPage} />
							<Route key={5} path="/reports/:reportname" exact component={CustomReport} />
							<Route key={6} path="/reports/:reportname/:id" exact component={CustomReport} />
							<Route key={7} path="/users" exact component={UsersPage} />
							<Route key={8} path="/user/:id" exact component={UserDetailsPage} />
							<Route key={9} path="/drugs" exact component={DrugPage} />
							<Route key={10} path="/units" exact component={UnitListPage} />
							<Route key={11} path="/settings" exact component={SettingsPage} />
							<Route key={12} path="/super/admin/settings" exact component={SuperAdminSettingsPage} />
							<Route key={13} path="/group/users/:userGroupId" exact component={GroupUserListPage} />
							<Route key={14} path="/drugs" exact component={DrugPage} />
							<Route key={15} path="/units" exact component={UnitListPage} />
							<Route key={16} path="/settings" exact component={SettingsPage} />
							<Route key={17} path="/unit/:id" exact component={UnitDetailsPage} />
							<Route key={18} path="/drug/:id" exact component={DrugDetailsPage} />
							<Route key={19} path="/drug_box/:id" exact component={DrugBoxDetailsPage} />
							<Route key={21} path="/group/create" exact component={CreateGroupPage} />
							<Route key={22} path="/activity" exact component={ActivityMapPage} />
						</Switch>
					</Router>
				</div>
        <PopupController ref={(ref) => (window.popupController = ref)} />
      </div>
		);
	}
}

export default App;



// WEBPACK FOOTER //
// ./src/App.jsx